<template>
  <div>
    <div style="background-color: #f6f6f6; padding-top: 10px" :id="id">
      <el-row>
        <el-col :sm="12">
          <p style="font-size: 15px; color: #9999a6">Chỉnh sửa hàng loạt
            &nbsp;&nbsp;<span style="color: #000000">{{ $t('base.selected') }} <span style="color: orangered;">0</span>
              loại hàng</span>
          </p>
        </el-col>
        <el-col :sm="12" class="text-right" style="padding-right: 5px">
          <el-button v-if="save_current_product" type="primary" size="mini" icon="el-icon-save"
                     :disabled="!product_selected_list.length" @click="m__show_create_flash_sale_filename_dialog">
            {{ $t('flash_sale.save_products_to_file') }}
          </el-button>
        </el-col>
      </el-row>
      <br>

      <table class="table table-no-border">
        <tr>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6"> {{ $t('base.discount') }}
                {{
                  form_update.discount_type === 'percent' ? `(% ${$t('flash_sale.discount')})` : `(${$t('base.amount')})`
                }}</small>
              <el-input size="mini" type="number" v-model="form_update.discount_value"></el-input>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('base.edit_type') }}</small>
              <el-select size="mini" v-model="form_update.discount_type">
                <el-option value="percent" :label="`% ${$t('flash_sale.discount')}`"></el-option>
                <el-option value="cash" :label="$t('base.amount')"></el-option>
              </el-select>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.campaign_stock') }}</small>
              <el-input size="mini" type="number" v-model="form_update.quantity"></el-input>
            </div>
          </td>
          <td style="width: 19%">
            <div style="padding: 0 15px 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.purchase_limit') }}</small><br>
              <el-select size="mini" value="" class="full-w" v-model="form_update.limit">
                <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                <el-option :label="$t('base.limited')" :value="1"></el-option>
              </el-select>
              <br>
            </div>
          </td>
          <td style="width: 40%">
            <small>&nbsp;</small><br>
            <el-button size="mini" type="primary" @click="m__update_multiple(false)">{{
                $t('base.mass_update')
              }}
            </el-button>
            <el-button size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                       @click="m__update_multiple(true)">{{ $t('base.update_selected') }}
            </el-button>
            <!--            <el-button v-if="show_enable" size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                                   @click="m__enable_multiple">{{ $t('base.mass_enable') }}
                        </el-button>-->
          </td>
        </tr>
        <tr>
          <td style="width: 15%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 19%">
            <div style="padding: 5px 15px 0 5px">
              <el-input v-if="form_update.limit === 1" type="number" size="mini" style="width: 100%"
                        v-model="form_update.limit_value"></el-input>
            </div>
          </td>
          <td style="width: 40%">
          </td>
        </tr>
      </table>
    </div>
    <div style="background-color: #f6f6f6;" :id="`${id}-fixed`" class="sticky-hide">
      <table class="table table-no-border" style="margin: 10px 0">
        <tr>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6"> {{ $t('base.discount') }}
                {{
                  form_update.discount_type === 'percent' ? `(% ${$t('flash_sale.discount')})` : `(${$t('base.amount')})`
                }}</small>
              <el-input size="mini" type="number" v-model="form_update.discount_value"></el-input>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('base.edit_type') }}</small>
              <el-select size="mini" v-model="form_update.discount_type">
                <el-option value="percent" :label="`% ${$t('flash_sale.discount')}`"></el-option>
                <el-option value="cash" :label="$t('base.amount')"></el-option>
              </el-select>
            </div>
          </td>
          <td style="width: 13%">
            <div style="padding: 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.campaign_stock') }}</small>
              <el-input size="mini" type="number" v-model="form_update.quantity"></el-input>
            </div>
          </td>
          <td style="width: 19%">
            <div style="padding: 0 15px 0 5px">
              <small style="color: #9999a6">{{ $t('flash_sale.purchase_limit') }}</small><br>
              <el-select size="mini" value="" class="full-w" v-model="form_update.limit">
                <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                <el-option :label="$t('base.limited')" :value="1"></el-option>
              </el-select>
              <br>
            </div>
          </td>
          <td style="width: 40%">
            <small>&nbsp;</small><br>
            <el-button size="mini" type="primary" @click="m__update_multiple(false)">{{
                $t('base.mass_update')
              }}
            </el-button>
            <el-button size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                       @click="m__update_multiple(true)">{{ $t('base.update_selected') }}
            </el-button>
            <el-button v-if="show_enable" size="mini" type="primary" v-bind:disabled="m__can_update_multiple()"
                       @click="m__enable_multiple">{{ $t('base.mass_enable') }}
            </el-button>
          </td>
        </tr>
        <tr>
          <td style="width: 15%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 13%">
          </td>
          <td style="width: 19%">
            <div style="padding: 5px 15px 0 5px">
              <el-input v-if="form_update.limit === 1" type="number" size="mini" style="width: 100%"
                        v-model="form_update.limit_value"></el-input>
            </div>
          </td>
          <td style="width: 40%">
          </td>
        </tr>
      </table>
    </div>

    <div style="margin-top: 15px">
      <el-row>
        <el-col :sm="12">
          <el-pagination
            :current-page.sync="page_filter.current_page" :page-size="page_filter.page_size"
            layout="prev, pager, next, total" :total="c__product_selected_filter_list.length"/>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-input size="mini" :placeholder="$t('input.placeholder')" style="max-width: 250px;"
                    prefix-icon="el-icon-search" v-model="page_filter.input_keyword" clearable/>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top: 15px">
      <table class="table table-no-border">
        <thead>
        <tr style="background-color: #f5f5f5">
          <th>
            <el-checkbox v-model="model_is_select_all" size="mini" @change="m__model_select_all_change"></el-checkbox>
          </th>
          <th>{{ $t('base.variation') }}</th>
          <th>Giá gốc</th>
          <th>Giá đã giảm</th>
          <th></th>
          <th>Khuyến mãi</th>
          <th>SL sản phẩm <br> khyến mãi</th>
          <th>Kho</th>
          <th>Giới hạn đặt hàng</th>
          <th>Trạng thái</th>
          <th v-if="show_enable">Tùy chọn</th>
          <!--          <th>{{ $t('base.action') }}</th>-->
        </tr>
        </thead>
        <template v-if="get_data">
          <tr>
            <td style="text-align: center;" colspan="11">
              <div style="padding-top: 20px">
                <i class="el-icon-loading"></i><strong> {{ $t('base.loading_data') }}</strong>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tbody>
          <tr>
            <td>
              <div style="height: 5px;"></div>
            </td>
          </tr>
          <template v-for="item in c__product_selected_display_list">
            <tr style="background-color: #f6f6f6; padding-top: 5px">
              <td>
                &nbsp;&nbsp;<el-checkbox size="mini" v-model="item.checked"
                                         @change="m__check_product(item)"></el-checkbox>
              </td>
              <td colspan="7">
                <div style="display: flex; align-items: center; gap: 5px; overflow: hidden">
                  <img :src="SHOPEE_IMAGE(item.product.images.split(',')[0])" alt="logo"
                       style="width:25px; height: 25px;">
                  &nbsp;
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shopee_id}.${item.product.itemid}`)">
                    {{ item.product.itemid }} - {{ item.product.name }}
                  </a>
                </div>
                <div style="display: flex; align-items: center; margin-top: 15px; margin-bottom: 10px">
                  <div>Tên hiển thị sản phẩm</div>
                  <div style="flex: 1; padding-left: 10px; padding-right: 50px">
                    <el-input size="mini" v-model="item.product.display_name"></el-input>
                  </div>
                </div>
              </td>
              <td>
                <el-select size="mini" value="" v-model="item.product.limit" :disabled="item.product.enable">
                  <el-option :label="$t('base.unlimited')" :value="0"></el-option>
                  <el-option :label="$t('base.limited')" :value="1"></el-option>
                </el-select>
              </td>
              <td>
                &nbsp;
              </td>
              <td v-if="show_enable" style="text-align: center">
                <template v-if="is_preview">
                  <el-button type="text" size="mini" @click="m__remove_product(item, 'delete_preview_entity')">
                    <strong>{{ $t('base.delete') }}</strong>
                  </el-button>
                </template>
                <template v-else>
                  <el-button type="text" size="mini" @click="m__remove_product(item, 'withdraw_entity')">
                    <strong>Hủy đăng ký</strong>
                  </el-button>
                </template>
              </td>
            </tr>
            <tr>
              <td>
                <div style="height: 5px"></div>
              </td>
            </tr>
            <template v-for="model in m__sort_model_list(item.model_list)">
              <tr :class="model.stock < 1 ? 'disabled-text' : ''">
                <td>
                  &nbsp;&nbsp;<el-checkbox size="mini" :disabled="model.stock < 1 || model.enable"
                                           v-model="model.checked"
                                           @change="m__model_item_checked_change"></el-checkbox>
                </td>
                <td style="width: 130px">
                  <div style="line-height: 20px">
                    <span style="font-weight: 600">{{ model.name || '-' }}</span>
                    <br>
                    <span style="font-size: 11px !important;" class="text-warning">
                      Mã: {{ model.modelid }}
                    </span>
                  </div>
                </td>
                <td>
                  <!--                  <pre>{{model}}</pre>-->
                  {{ model.price | currency }} ₫
                </td>
                <td style="width: 100px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            @input="m__model_update_discount_price(item, model)"
                            v-bind:value="model.discount_price"
                            v-model="model.discount_price" :min="1000" :max="model.price"></el-input>
                </td>
                <td style="text-align: center">
                  hoặc (%)
                </td>
                <td style="width: 100px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            @input="m__model_update_discount_percent(item, model)"
                            v-model="model.discount_percent" :min="3"></el-input>
                </td>
                <td style="width: 130px; padding-left: 15px">
                  <el-input type="number" size="mini" :disabled="model.stock < 1 || model.enable"
                            v-model="model.quantity" :min="1" :max="model.stock"></el-input>
                </td>
                <td style="text-align: center">
                  <!--                  {{ model.enable ? model.stock - model.quantity : model.stock }}-->
                  {{ model.stock }}
                </td>
                <td style="width: 150px">
                  <template v-if="item.product.limit === 0">
                    Không giới hạn
                  </template>
                  <template v-if="item.product.limit === 1">
                    <el-input size="mini" type="number" :min="1" v-model="item.product.limit_value"
                              :disabled="model.stock < 1 || model.enable"></el-input>
                  </template>
                </td>
                <td v-if="show_enable">
                  <template v-if="!is_preview && model.review_status">
                    <span v-if="model.review_status === 1" style="font-size: 13px" class="text-success">Đã duyệt</span>
                    <span v-else-if="model.review_status === 3" style="font-size: 13px">Chờ xác nhận</span>
                    <span v-else style="font-size: 13px">{{ model.review_status }}</span>
                  </template>
                </td>
                <td v-if="show_enable" style="text-align: center">
                  <!--                  <template v-if="is_preview">
                                      <el-button type="text" size="mini">
                                        <strong>{{ $t('base.delete') }}</strong>
                                      </el-button>
                                    </template>
                                    <template v-else>
                                      <el-button v-if="!model.review_status && model.enable" type="text" size="mini"
                                                 @click="model.enable = false">
                                        <strong>Đăng ký</strong>
                                      </el-button>
                                      <el-button v-else type="text" size="mini">
                                        <strong>Hủy đăng ký</strong>
                                      </el-button>
                                    </template>-->
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td colspan="11">
                  <span v-if="model.error_message" class="text-danger" v-html="`Lỗi: ${ model.error_message }`"></span>
                </td>
              </tr>
            </template>
            <!--<tr>
                          <td colspan="12">
                            <span v-if="item.product.error_message" class="text-danger">Lỗi: {{ item.product.error_message }}</span>
                          </td>
                        </tr>-->
            <tr>
              <td>
                <div style="height: 5px;"></div>
              </td>
            </tr>
          </template>
          </tbody>
        </template>
      </table>
    </div>

    <div style="margin-top: 15px">
      <el-row>
        <el-col :sm="12">
          <el-pagination
            :current-page.sync="page_filter.current_page" :page-size="page_filter.page_size"
            layout="prev, pager, next, total" :total="c__product_selected_filter_list.length"/>
        </el-col>
        <el-col :sm="12">
        </el-col>
      </el-row>
    </div>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__create_flash_sale_file" icon="el-icon-check"
                     :loading="loading.create_flash_sale_file"> {{ $t('flash_sale.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  drop as _drop,
  take as _take,
  orderBy as _orderBy
} from 'lodash'
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'component_flash_sale_product',

  mixins: [fix_ads_mixins],

  props: {
    id: {
      type: String,
      default: 'stick'
    },
    seller: {
      type: Object,
      default: {}
    },
    product_selected_list: {
      type: Array,
      default: []
    },
    // flash_sale_created: {type: Array, default: []},
    is_edit_component: {
      type: Boolean,
      default: false
    },
    save_current_product: {
      type: Boolean,
      default: true
    },
    flash_sale: {
      type: Object,
      default: null
    },
    shop_id: {
      type: String,
      default: ''
    },
    shopee_id: {
      type: String,
      default: ''
    },
    show_enable: {
      type: Boolean,
      default: true
    },
    get_data: {
      type: Boolean,
      default: false
    },
    is_preview: {
      type: Boolean,
      default: false
    },
    campaigns: {
      type: Array,
      default: []
    },
  },

  data() {
    return {
      campaign: {},
      model_is_select_all: false,
      form_update: {
        discount_type: 'percent',
        discount_value: null,
        discount_percent: null,
        quantity: null,
        limit: 0,
        limit_value: null
      },
      sticky_block: null,
      filename: '',
      show_dialog: {create_flash_sale_filename: false},
      loading: {create_flash_sale_file: false},
      page_filter: {
        page_size: 10,
        current_page: 0,
        input_keyword: ''
      }
    }
  },

  beforeMount() {
    this.campaign = this.campaigns[0]
  },

  watch: {
    'product_selected_list': function () {
      // this.m__get_product_detail()
    }
  },

  mounted() {
    this.sticky_block = document.getElementById(`${this.id}-fixed`)

    const sticky = document.getElementById(this.id)
    this.sticky_block_offset = sticky.offsetTop + sticky.clientHeight
    document.querySelector('#dashboard-wrapper').addEventListener('scroll', this.m__handle_scroll)

    // this.m__get_product_detail()
  },

  destroyed() {
    document.querySelector('#dashboard-wrapper').removeEventListener('scroll', this.m__handle_scroll)
  },

  computed: {
    c__product_selected_filter_list() {
      const keyword = this.remove_unicode(this.page_filter.input_keyword)
      return this.product_selected_list.filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(keyword)))
    },

    c__product_selected_display_list() {
      const limit = this.page_filter.page_size
      const skip = limit * (this.page_filter.current_page - 1)
      return _take(_drop(this.c__product_selected_filter_list, skip), limit)
    }
  },

  methods: {
    m__sort_model_list(model_list) {
      return _orderBy(model_list, ['name'], ['asc'])
    },

    async m__get_product_detail() {
      if (!this.seller || !this.product_selected_list.length) return

      const response = await this.seller.get_product_by_graphql(this.product_selected_list.map(i => i.product.itemid.toString()))
      if (response.data && response.data.products && response.data.products.items) {
        for (const item of response.data.products.items) {
          const product_found = this.product_selected_list.find(i => i.product.itemid === +item.itemid)
          if (!product_found) continue

          for (const model of item.modelList) {
            const model_found = product_found.model_list.find(i => i.modelid === +model.modelid)
            if (model_found) model_found.name = model.name
          }
        }
      }
    },

    m__handle_scroll() {
      if (!this.save_current_product) {
        return
      }

      const scroll_top = document.getElementById('dashboard-wrapper').scrollTop - 300
      // console.log('a', scroll_top)
      // console.log('b', this.sticky_block_offset)
      if (scroll_top > this.sticky_block_offset) {
        this.sticky_block.classList.remove('sticky-hide')
        this.sticky_block.classList.add('sticky')
      } else {
        this.sticky_block.classList.remove('sticky')
        this.sticky_block.classList.add('sticky-hide')
      }
    },

    m__can_update_multiple() {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.checked) {
            return false
          }
        }
      }
      return true
    },

    m__update_multiple(selected = false) {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (!selected && model.stock > 0 && !model.enable) {
            if (this.form_update.limit === 0 || (this.form_update.limit === 1 && this.form_update.limit_value)) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity <= model.stock ? this.form_update.quantity : model.stock
            }
          }

          if (selected && model.checked && model.stock > 0 && !model.enable) {
            if (this.form_update.limit && this.form_update.limit_value) {
              item.product.limit = this.form_update.limit
              item.product.limit_value = this.form_update.limit_value
            }

            if (this.form_update.discount_type === 'percent' && this.form_update.discount_value) {
              model.discount_percent = this.form_update.discount_value
              this.m__model_update_discount_percent(item, model)
            }
            if (this.form_update.discount_type === 'cash' && this.form_update.discount_value) {
              model.discount_price = this.form_update.discount_value
              this.m__model_update_discount_price(item, model)
            }

            if (this.form_update.quantity) {
              model.quantity = this.form_update.quantity <= model.stock ? this.form_update.quantity : model.stock
            }
          }
        }
      }
    },

    async m__enable_multiple() {
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.checked && model.stock > 0) {
            item.product.enable = true
            await this.m__product_enable_change(item, false)
          }
        }
      }
    },

    m__model_select_all_change() {
      this.product_selected_list.forEach(i => {
        i.checked = this.model_is_select_all
        i.model_list.forEach(ii => ii.checked = this.model_is_select_all)
      })
    },

    m__check_product(product) {
      if (product.checked) {
        product.model_list.forEach(ii => ii.checked = true)
      } else {
        product.model_list.forEach(ii => ii.checked = false)
      }

      this.m__model_item_checked_change()
    },

    m__model_item_checked_change() {
      for (const item of this.product_selected_list) {
        const checked_number = item.model_list.reduce((total, model) => {
          if (model.checked) total++
          return total
        }, 0)
        item.checked = item.model_list.length === checked_number
      }

      const checked_number = this.product_selected_list.reduce((result, item) => {
        result[0] += item.model_list.length
        result[1] += item.model_list.filter(i => i.checked).length
        return result
      }, [0, 0])

      this.model_is_select_all = checked_number[0] === checked_number[1]
    },

    async m__remove_product(item, type) {
      this.$emit('m__remove_product', {
        item,
        type
      })
    },

    async m__product_enable_change(item, unchecked = true) {
      if (item.product.enable) {
        for (const i of item.model_list) {
          if (i.stock > 0) {
            i.enable = true
            await this.m__model_enable_change(item, i, unchecked, true)
          } else {
            i.enable = false
          }
        }
      } else {
        item.model_list.forEach(i => i.enable = false)
      }

      if (unchecked) {
        this.model_is_select_all = false
        this.product_selected_list.forEach(i => {
          i.checked = false
          i.model_list.forEach(ii => ii.checked = false)
        })
      }
    },

    m__model_update_discount_percent(item, model) {
      if (model.discount_percent > 100) {
        model.discount_percent = 100
      } else if (model.discount_percent < 0) {
        model.discount_percent = 0
      }

      model.discount_price = this.m__calculate(model.price - (model.price * model.discount_percent / 100))
      model.error_message = ''
    },

    async m__model_enable_change(item, model, unchecked = true, submit = false) {
      if (model.discount_percent > 90 || model.discount_percent < 5) {
        model.error_message = this.$t('flash_sale.discount_percent_between_x_y', {
          x: '5',
          y: '90'
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity < 1 || model.quantity > model.stock) {
        model.error_message = this.$t('flash_sale.promotion_quantity_between_x_y', {
          x: '1',
          Y: model.stock
        })
        model.enable = false
        item.product.enable = false
        return
      }

      if (model.quantity > 1000) {
        model.error_message = this.$t('flash_sale.promotion_quantity_lt_x', {x: '1000'})
        model.enable = false
        item.product.enable = false
        return
      }

      // if (model.quantity * this.flash_sale_created.length > model.stock) {
      //   model.error_message = this.$t('flash_sale.evenly_every_days')
      //   model.enable = false
      //   item.product.enable = false
      //   return
      // }

      const available_number = item.model_list.filter(i => i.stock > 0).length
      const enable_number = item.model_list.filter(i => i.enable).length
      item.product.enable = available_number === enable_number
      item.product.error_message = ''

      if (unchecked) {
        this.model_is_select_all = false
        this.product_selected_list.forEach(i => {
          i.checked = false
          i.model_list.forEach(ii => ii.checked = false)
        })
      }

      if (model.enable) {
        model.error_message = ''
      }

      if (this.is_edit_component) {
        model.error_message = ''

        return

        // await this.m__save_and_apply()

        // const data = {
        //   'item_list': [
        //     {
        //       'item_id': item.product.itemid,
        //       'item_display_name': item.product.display_name,
        //       'item_display_image': '78bd8fb01a9534a68a748b7bfb368ae3',
        //       'product_purchase_limit': item.product.limit === 1 && item.product.limit_value ? item.product.limit_value : 0,
        //       'model_list': [
        //         {
        //           'model_id': model.model_id,
        //           'product_promotion_price': '89000',
        //           'product_promotion_stock': 12,
        //           'nomination_source': 2
        //         }
        //       ]
        //     }
        //   ],
        //   'cluster_id': 45535
        // }
      }
    },

    m__model_update_discount_price(item, model) {
      if (model.discount_price > model.price) {
        model.discount_price = model.price
      } /*else if (model.discount_price < 1000) {
        model.discount_price = 1000
      }*/

      model.discount_percent = 100 - Math.ceil(model.discount_price * 100 / model.price)
      model.error_message = ''
    },

    async m__save_and_apply(ntf = false) {
      const form = {
        flash_sale_id: this.flash_sale.flash_sale_id,
        items: []
      }
      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (model.stock > 0) {
            form.items.push({
              item_id: item.product.itemid,
              model_id: model.modelid,
              input_promo_price: model.discount_price,
              purchase_limit: item.product.limit === 1 && item.product.limit_value ? item.product.limit_value : 0,
              status: model.enable ? 1 : 0,
              stock: +model.quantity
            })
          }
        }
      }

      if (form.items.length) {
        const resp = await this.seller.flash_sale_save_batch_items(form)
        // console.log(resp)
        if (resp && resp.data && resp.data.failed_items) {
          for (const item of resp.data.failed_items) {
            const product_found = this.product_selected_list.find(i => i.product.itemid === item.item_id)
            if (product_found) {
              const model_found = product_found.model_list.find(i => i.modelid === item.model_id)
              if (model_found) {
                product_found.product.enable = false
                model_found.enable = false
                model_found.error_message = `${this.$t('flash_sale.api_error_response')}: ${item.err_msg}`
              }
            }
          }
        }
      }

      if (ntf) this.ntf_s(this.$t('flash_sale.updated_message'))
    },

    m__show_create_flash_sale_filename_dialog() {
      this.filename = ''
      this.show_dialog.create_flash_sale_filename = true
    },

    async m__create_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }
      if (!this.product_selected_list.length) {
        this.ntf_w(this.$t('required.select_products'))
        return
      }
      // console.log(this.product_selected_list)

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        filename: this.filename,
        products: this.product_selected_list.map(i => ({
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list.map(ii => ({
            ...ii,
            enable: false,
            checked: false
          })))
        })),
        shopId: this.shop_id,
        isOfficial: true
      }

      try {
        this.loading.create_flash_sale_file = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.create_flash_sale_filename = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.create_flash_sale_file = false
      }
    },

    m__get_flash_sale_files() {
      this.$emit('m__get_flash_sale_files')
    }
  }
}
</script>

<style lang="scss">
.sticky-hide {
  display: none;
}

.sticky {
  width: calc(100vw - 269px);
  display: block;
  position: fixed;
  top: 0;
  z-index: 10;

  p, br {
    display: none;
  }
}

.table > thead > tr > th {
  vertical-align: text-top !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale_shopee/product.vue